import { render, staticRenderFns } from "./EditKnowledgeBaseDialog.vue?vue&type=template&id=078c4d93"
import script from "./EditKnowledgeBaseDialog.vue?vue&type=script&lang=js"
export * from "./EditKnowledgeBaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports